// 移动设备中  是否存在某个文件
export function HasEcgFile(fileName){
  return new Promise(function (resolve,reject) {
    window.HasEcgFile(fileName,function (result) {
      if(result){
        resolve(result);
      }else{
        reject("HasEcgFile error");
      }
    });
  });
}

// 获得浏览器版本
export function getVersion(){
  return new Promise(function (resolve,reject) {
    window.getVersion(function (result) {
      if(result){
        resolve(result);
      }else{
        reject("getVersion error");
      }
    });
  });
}
// 更新浏览器版本 BeginUpdate
export function BeginUpdate(version,url){
  return new Promise(function (resolve,reject) {
    window.BeginUpdate(version,url,function (result) {
      if(result){
        resolve(result);
      }else{
        reject("BeginUpdate error");
      }
    });
  });
}

// 获得操作系统版本
export function getOsVersion(){
  return new Promise(function (resolve,reject) {
    window.getOsVersion(function (result) {
      if(result){
        resolve(result);
      }else{
        reject("getOsVersion error");
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/browser.js